import React from "react";
import { Cookie } from "lucide-react";

const CookiesPolicy = () => {
  return (
    <div className="bg-[#0C2340] p-2 md:!p-6 flex flex-col items-center">
      
      <div className="w-full bg-white/10 backdrop-blur-md shadow-xl rounded-2xl p-8 border border-white/20">
      <h1 className=" text-3xl md:text-3xl font-extrabold text-center mb-8 flex items-center text-blue-300">
        <Cookie className="mr-3 text-blue-300" size={35} /> Cookies Policy
      </h1>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          Our website uses cookies to enhance user experience, analyze site traffic, and improve our services. By using our site, you agree to our use of cookies as described in this policy.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">What Are Cookies?</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>Cookies are small text files stored on your device to improve browsing experience.</li>
          <li>They help remember user preferences and provide personalized content.</li>
          <li>Some cookies are necessary for website functionality.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">How We Use Cookies</h2>
        <ul className="text-gray-100 text-lg leading-relaxed mb-6 list-disc pl-6">
          <li>To analyze website traffic and user interactions.</li>
          <li>To remember user preferences and settings.</li>
          <li>To provide relevant advertisements and improve marketing efforts.</li>
        </ul>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Managing Cookies</h2>
        <p className="text-gray-100 text-lg leading-relaxed mb-6">
          Users can manage or disable cookies through their browser settings. However, disabling cookies may affect website functionality and user experience.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-blue-300 mb-4 border-b border-blue-300 pb-2">Changes to Policy</h2>
        <p className="text-gray-100 text-lg leading-relaxed">
          We may update this Cookies Policy periodically. Any changes will be posted on this page with an updated effective date. Users are encouraged to review this policy regularly.
        </p>
      </div>
    </div>
  );
};

export default CookiesPolicy;
